import React from "react";
import { ActivityIcon, BoneIcon, BookOpenIcon, BrainIcon, ClockIcon, SplitIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { situations } from "../data/landing";
const iconMap = {
  bone: BoneIcon,
  clock: ClockIcon,
  split: SplitIcon,
  book: BookOpenIcon,
  brain: BrainIcon,
  run: ActivityIcon
};
export function Situations() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="situations" data-id="element-256" data-mp="10xps3mxn7uck">
      <div className="mx-auto max-w-5xl" data-id="element-257" data-mp="15wk7sg0bd2sg">
        <SectionHeading title={<span id="situations" data-id="element-259" data-mp="1aokbmjji8fub">Do you recognize yourself in any of these situations?</span>} intro="If you answer YES to any of these questions, this resource was designed with your learning and reference needs in mind." data-id="element-258" data-mp="15viue4vts47k" />

        <ul className="grid gap-4 md:grid-cols-2" data-id="element-260" data-mp="1jqlatlyatbym">
          {situations.map(s => {
          const Icon = iconMap[s.icon];
          return <li key={s.title} className="flex gap-4 rounded-2xl bg-panel p-5" data-id="element-261" data-mp="3lhoaddtwp0jb">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cyan/15 text-cyan" data-id="element-262" data-mp="3lflbe4arzx2g">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-263" data-mp="3cgzx4lcc747h" />
                </span>
                <div data-id="element-264" data-mp="37i53eoctzv8l">
                  <h3 className="text-[17px] font-bold leading-snug text-white" data-id="element-265" data-mp="37iyaxrjm6ors">{s.title}</h3>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-mist" data-id="element-266" data-mp="9112twqu5u55">{s.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-cyan px-6 py-8 text-center text-ink" data-id="element-267" data-mp="43sl1x9lns4f">
          <p className="font-display text-[28px] font-extrabold uppercase leading-tight sm:text-4xl" data-id="element-268" data-mp="3vdra6d1acn33">
            The problem isn't simply that you need to memorize more tests.
          </p>
          <p className="mt-4 text-[16px] font-medium leading-relaxed" data-id="element-269" data-mp="rt3l1cj4lihi">
            The challenge is organizing the information those tests provide and interpreting it in the appropriate
            clinical context. That's why the Blueprint™ brings the essential elements together in one organized system.
          </p>
        </div>

        <CtaButton className="mt-10" label="Get the complete system" data-id="element-270" data-mp="27iuvalgvp1kq" />
      </div>
    </section>;
}